import React from 'react'
import { Container, Subscribe, Provider } from 'unstated'

class ViewportContainer extends Container {
  constructor() {
    super()

    this.state = {}
    this.resizeFns = []
    this.scrollFns = []

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
      window.addEventListener('scroll', this.handleScroll)
      
      this.state = {
        vw: window.innerWidth,
        vh: window.innerHeight,
        x: window.pageXOffset,
        y: window.pageYOffset,
      }

      this.lastvw = this.state.vw
      this.lastvh = this.state.vh
      this.lasty = this.state.y
      this.lastx = this.state.x
    }
  }

  headerHeight = 80

  get vw() { return this.state.vw }
  get vh() { return this.state.vh }
  get x() { return this.state.x }
  get y() { return this.state.y }
  get scrollDir() { return this.y > this.lasty ? 1 : -1}
  get scrollSpeed() { return Math.abs(this.y - this.lasty) }

  handleResize = (e) => {
    this.lastvw = this.state.vw
    this.lastvh = this.state.vh

    this.setState({
      vw: window.innerWidth,
      vh: window.innerHeight,
    })

    this.resizeFns.forEach(fn => fn(e))

    this.handleUpdate()
  }

  handleScroll = (e) => {
    this.setState({
      x: window.pageXOffset,
      y: window.pageYOffset,
    }).then(() => {
      this.scrollFns.forEach(fn => fn(e))
      this.handleUpdate()
  
      this.lastx = this.state.x
      this.lasty = this.state.y
    })
  }

  handleUpdate = () => {
    if (this.headerRef && this.headerRef.current) {
      this.headerHeight = this.headerRef.current.clientHeight
    }
  }

  setHeaderRef = (ref) => {
    this.headerRef = ref
  }

  onResize = (cb) => {
    if (this.resizeFns.indexOf(cb) > -1) {
      return
    }

    this.resizeFns.push(cb)
  }

  offResize = (cb) => {
    const index = this.resizeFns.indexOf(cb)
    if (index === -1) {
      return
    }

    this.resizeFns.splice(index, 1)
  }

  onScroll = (cb) => {
    if (this.scrollFns.indexOf(cb) > -1) {
      return
    }

    this.scrollFns.push(cb)
  }

  offScroll = (cb) => {
    const index = this.scrollFns.indexOf(cb)
    if (index === -1) {
      return
    }

    this.scrollFns.splice(index, 1)
  }
}

const viewportContainer = new ViewportContainer()

export default viewportContainer

export const ViewportSubscriber = ({ children }) => (
  <Provider>
    <Subscribe to={[viewportContainer]}>
      { children }
    </Subscribe>
  </Provider>
)